<template>
  <v-dialog v-model="open" max-width="900px" persistent>
    <v-card>
      <v-card-title class="d-flex align-center">
        <div>
          <div class="text-h6">Running Balance</div>
          <div class="text-caption" v-if="userLabel">
            {{ userLabel }}
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div v-if="loading" class="py-8 d-flex justify-center">
          <v-progress-circular indeterminate size="36"></v-progress-circular>
        </div>

        <div v-else>
          <v-alert type="info" dense v-if="!rows.length">
            No transactions found.
          </v-alert>

          <v-data-table
            v-else
            :headers="headers"
            :items="rows"
            :items-per-page="15"
            dense
          >
            <template v-slot:item.amount="{ item }">
              <div class="text-right">
                {{ formatAmount(item.amount) }}
              </div>
            </template>

            <template v-slot:item.running_balance="{ item }">
              <div class="text-right font-weight-bold">
                {{ formatAmount(item.running_balance) }}
              </div>
            </template>

            <template v-slot:item.transdate="{ item }">
              <span>{{ formatDate(item.transdate) }}</span>
            </template>
          </v-data-table>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TransactionService from '@/services/TransactionService'

export default {
  name: 'RunningBalanceModal',
  props: {
    value: { type: Boolean, default: false }, // v-model
    userId: { type: [Number, String], default: null },
    userLabel: { type: String, default: '' } // optional display name
  },
  data () {
    return {
      open: this.value,
      loading: false,
      rows: [],
      headers: [
        { text: 'Date', value: 'transdate', sortable: false },
        { text: 'Type', value: 'transtype', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Bet Type', value: 'bettype', sortable: false },
        { text: 'Amount', value: 'amount', sortable: false, align: 'end' },
        { text: 'Running Balance', value: 'running_balance', sortable: false, align: 'end' }
      ]
    }
  },
  watch: {
    value (v) {
      this.open = v
      if (v) this.load()
    },
    open (v) {
      this.$emit('input', v)
    },
    userId () {
      // if modal is open and user changes (click different user), reload
      if (this.open) this.load()
    }
  },
  methods: {
    close () {
      this.open = false
    },
    async load () {
      if (!this.userId) return
      this.loading = true
      this.rows = []
      try {
        const res = await TransactionService.getUserRunningBalanceTransactions(this.userId)
        // depending on your backend shape:
        // res.data.transactions OR res.data
        this.rows = res.data.transactions || res.data || []
      } catch (e) {
        console.error(e)
        this.rows = []
      } finally {
        this.loading = false
      }
    },
    formatAmount (amount) {
      const n = Number(amount || 0)
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n)
    },
    formatDate (d) {
      if (!d) return ''
      // keep it simple; d might already be ISO/SQL string
      return String(d).replace('T', ' ')
    }
  }
}
</script>
